var map = {
	"./Scissors.svg": [
		32426,
		9
	],
	"./add_to_cart.svg": [
		19094,
		9,
		94
	],
	"./arrow.svg": [
		8563,
		9,
		563
	],
	"./arrowDown.svg": [
		29873,
		9,
		873
	],
	"./back.svg": [
		22330,
		9,
		330
	],
	"./calendar.svg": [
		76168,
		9,
		168
	],
	"./cart.svg": [
		9296,
		9,
		296
	],
	"./cart_view_less.svg": [
		6377,
		9,
		377
	],
	"./cart_view_more.svg": [
		98368,
		9,
		368
	],
	"./check.svg": [
		33689,
		9,
		689
	],
	"./checkmark.svg": [
		96028,
		9,
		28
	],
	"./checkmark_green.svg": [
		19483,
		9,
		483
	],
	"./clock.svg": [
		52834,
		9,
		834
	],
	"./closeBig.svg": [
		18394,
		9,
		394
	],
	"./close_black.svg": [
		48467,
		9,
		467
	],
	"./close_white.svg": [
		90069,
		9,
		69
	],
	"./dark_left_arrow.svg": [
		85785,
		9
	],
	"./dark_right_arrow.svg": [
		43672,
		9
	],
	"./delete.svg": [
		87393,
		9,
		393
	],
	"./desktopUploadDocument.svg": [
		14426,
		9
	],
	"./doc.svg": [
		44196,
		9,
		196
	],
	"./docx.svg": [
		56483,
		9,
		599
	],
	"./double-arrow-left.svg": [
		69974,
		9
	],
	"./double-arrow-right.svg": [
		25304,
		9
	],
	"./download.svg": [
		80381,
		9
	],
	"./duplicate_cart.svg": [
		52795,
		9,
		795
	],
	"./edit.svg": [
		41700,
		9,
		700
	],
	"./error.svg": [
		48036,
		9
	],
	"./exported_list.svg": [
		68063,
		9,
		63
	],
	"./file.svg": [
		13310,
		9,
		310
	],
	"./folder.svg": [
		60466,
		9,
		466
	],
	"./go_to_wish_list.svg": [
		88039,
		9,
		39
	],
	"./info.svg": [
		24483,
		9,
		430
	],
	"./info2.svg": [
		41583,
		9,
		583
	],
	"./left_arrow.svg": [
		46420,
		9
	],
	"./link.svg": [
		10497,
		9,
		497
	],
	"./menu.svg": [
		56333,
		9,
		333
	],
	"./menu_2.svg": [
		81897,
		9,
		897
	],
	"./mobileUploadDocument.svg": [
		12872,
		9
	],
	"./move.png": [
		66789,
		1,
		789
	],
	"./move.svg": [
		1013,
		9,
		13
	],
	"./move_to_cart.svg": [
		490,
		9,
		490
	],
	"./move_to_wish_list.svg": [
		18570,
		9,
		570
	],
	"./nickname.svg": [
		21609,
		9,
		609
	],
	"./pdf.svg": [
		74053,
		9,
		53
	],
	"./pencil.svg": [
		71448,
		9,
		448
	],
	"./pencil_section.svg": [
		69956,
		9
	],
	"./ppt.svg": [
		52397,
		9,
		397
	],
	"./pptx.svg": [
		1126,
		9,
		126
	],
	"./process.svg": [
		39622,
		9,
		622
	],
	"./profile-notification.svg": [
		88929,
		9,
		929
	],
	"./proof.svg": [
		78849,
		9
	],
	"./proof_approval.svg": [
		57873,
		9,
		792
	],
	"./right_arrow.svg": [
		45081,
		9
	],
	"./search.svg": [
		76621,
		9,
		621
	],
	"./success.svg": [
		58828,
		9,
		828
	],
	"./tick.svg": [
		15469,
		9
	],
	"./uncheck.svg": [
		65330,
		9,
		214
	],
	"./upload.svg": [
		84912,
		9,
		912
	],
	"./user.svg": [
		203,
		9,
		203
	],
	"./warning.svg": [
		64630,
		9,
		630
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 98146;
module.exports = webpackAsyncContext;